import { render, staticRenderFns } from "./BigText.vue?vue&type=template&id=4e8a30f0"
import script from "./BigText.vue?vue&type=script&lang=js"
export * from "./BigText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports